import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Rating from '@material-ui/lab/Rating';
// import Box from '@material-ui/core/Box';
// import styled from 'styled-components'
// const labels = {
//     0.5: 'Useless',
//     1: 'Useless+',
//     1.5: 'Poor',
//     2: 'Poor+',
//     2.5: 'Ok',
//     3: 'Ok+',
//     3.5: 'Good',
//     4: 'Good+',
//     4.5: 'Excellent',
//     5: 'Excellent+',
// };

const useStyles = makeStyles({
    rating: {
        width: 200,
        display: 'flex',
        alignItems: 'center',
    },
});

export const Rate = (props) => {
    //   const [value, setValue] = React.useState(2);
    //   const [hover, setHover] = React.useState(-1);
    // const classes = useStyles();

    return (
        <Rating
            {...props}
        // onChange={(event, newValue) => {
        //   setValue(newValue);
        // }}
        // onChangeActive={(event, newHover) => {
        //   setHover(newHover);
        // }}
        />
    );
}